module.exports = __webpack_public_path__ + "static/media/elk.eefa4fb1.jpg";